export default __webpack_public_path__ + "static/media/gallery_08.07c8f976.jpg";